<template>
  <div id="app">
    <compotent :is="layout" v-if="$route.name" />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    layout() {
      return (this.$route.meta.layout || 'default') + '-layout';
    }
  }
}
</script>

<style>
html {
  box-sizing: border-box;
  font-size: 14px;
  font-family: "Helvetica Neue", Arial, "Hiragino kaku Gothic ProN", "Hiragino Sans", Meiryo, sans-serif;
  height: 100%;
}
body {
  margin: 0;
  font-size: 1rem;
  height: 100%;
}
#app {
  height: 100%;
}
*,
*::before,
*::after {
  box-sizing: inherit;
}
</style>